import { CssBaseline, ThemeProvider as MuiThemeProvider } from '@mui/material';
import * as Sentry from '@sentry/react';
import { setAutoFreeze } from 'immer';
import moment from 'moment';
import 'moment/locale/ja';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { bootstrapApp } from './bootstrap';
import setChartjsDefaults from './common/charts/ChartjsDefaults';
import { DisableAccessIfMobile } from './common/components/shell/DisableAccessIfMobile';
import { defaultTheme } from './common/theme/default-theme';
import { muiTheme } from './common/theme/mui-theme';
import { BetterSuspense } from './common/v2/common/components/BetterSuspense';
import { UnauthedErrorBoundary } from './common/v2/common/components/errors/boundaries/UnauthedErrorBoundary';
import { LoadingOverlay } from './common/v2/common/components/LoadingOverlay';
import { UnauthenticatedContextProvider } from './common/v2/context/UnauthenticatedContextProvider';
import { addPolyfills } from './polyfills';
import { Routes } from './Routes';
import { RoutesWrapper } from './RoutesWrapper';

addPolyfills();
setAutoFreeze(false); // See https://immerjs.github.io/immer/freezing/
bootstrapApp();
setChartjsDefaults();
moment.locale('en');

const App = () => {
  const clientPrimary = '#00a599';
  defaultTheme.color.clientPrimary = clientPrimary;

  return (
    <>
      <RoutesWrapper>
        <CssBaseline />
        <MuiThemeProvider theme={muiTheme}>
          <ThemeProvider theme={defaultTheme}>
            <DisableAccessIfMobile>
              <UnauthenticatedContextProvider>
                <UnauthedErrorBoundary>
                  <SnackbarProvider>
                    <BetterSuspense fallback={<LoadingOverlay />}>
                      <Routes />
                    </BetterSuspense>
                  </SnackbarProvider>
                </UnauthedErrorBoundary>
              </UnauthenticatedContextProvider>
            </DisableAccessIfMobile>
          </ThemeProvider>
        </MuiThemeProvider>
      </RoutesWrapper>
    </>
  );
};

export default Sentry.withProfiler(App);
